import ngTranslate from 'angular-translate';
import uiRouter from '@uirouter/angularjs';
import assign from 'lodash/assign';

import { MyAccountServiceModule } from 'services/data/myAccount.service';
import { LaunchChangePlanServiceModule } from 'components/changePlan/launchChangePlan.service';
import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';
import { StoreInformationServiceModule } from 'services/data/storeInformation.service';

import { TrialServiceModule } from './trial.service';
import template from './trialStatusBar.html';
import './trialStatusBar.scss';

export const TrialStatusBarModule = angular
    .module('app.components.trialStatusBar', [
        ngTranslate,
        uiRouter,
        MyAccountServiceModule,
        LaunchChangePlanServiceModule,
        LaunchDarklyServiceModule,
        StoreInformationServiceModule,
        TrialServiceModule
    ]).component('trialStatusBar', {
        template,
        bindings: {
            trialStatus: '<'
        },
        controller: class TrialStatusBar {
            constructor(
                launchChangePlanService,
                trialService,
                myAccountService,
                launchDarklyService,
                storeInformationService,
                $translate,
                $rootScope,
                $state
            ) {
                'ngInject';

                assign(this, {
                    launchChangePlanService,
                    trialService,
                    myAccountService,
                    launchDarklyService,
                    storeInformationService,
                    $translate,
                    $rootScope,
                    $state,
                    showClass: 'trial-status-bar-open',
                    translationKeys: [
                        'TRIALSTATUSBAR.TIMEREMAINING',
                        'TRIALSTATUSBAR.TIMEREMAININGSHORT',
                        'TRIALSTATUSBAR.TRIALEXPIRED',
                        'TRIALSTATUSBAR.TRIALEXPIREDSHORT'
                    ]
                });
            }

            $onInit() {
                this.myAccountService.getUser().then((user) => {
                    this.name = user.firstName;
                    this.$translate(this.translationKeys, {
                        NAME: this.name,
                        TIMEREMAINING: this.trialStatus
                    }).then((translations) => {
                        this.translations = translations;
                        this.handlePageChange(this.$state.current.name);
                    });
                });

                this.unbindStateChangeSuccess = this.$rootScope.$on('$stateChangeSuccess', (event, toState) => {
                    this.handlePageChange(toState.name);
                });

                this.launchDarklyService.isElementStore(this.storeInformationService)
                    .then(isElementStore => this.isElementStore = isElementStore);
            }

            $onDestroy() {
                this.hide();
                this.unbindStateChangeSuccess();
            }

            openPlans(ev) {
                this.launchChangePlanService.openModal(ev, null, true);
            }

            handlePageChange(stateName) {
                this.stateName = stateName;
                if (this.stateIsDashboard()) {
                    this.hide();
                } else {
                    this.show();
                }
            }

            stateIsDashboard() {
                return false; // The status bar is showing everywhere in the trial now
            }

            show() {
                angular.element('body').addClass(this.showClass);
            }

            hide() {
                angular.element('body').removeClass(this.showClass);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/trial/trialStatusBar.js